<header *ngIf="isMobileTheme || isTabletTheme; else desktopTheme" role="banner" [ngClass]="isMobileTheme ? 'fw-Header-mobile' : 'fw-Header-tablet'">
    <div class="fw-HeaderComponent_Mobile">
        <div class="fw-Header-menu">
            <modern-nxi-mobile *ngIf="!hideNavigation && (isLoggedIn || isDisclosuresPage)" [isMobileTheme]="isMobileTheme" [isTabletTheme]="isTabletTheme">
            </modern-nxi-mobile>
            <!-- Mobile Logo-->
            <a tabindex="-1" href="javascript:void(0);" (click)="redirectHome()">
                <div tabindex="0" attr.aria-label="{{'NXI_PORTAL.LOGOPRELOGIN' | pershingTranslate}} {{ibdName}}"
                    class="fw-Header_Logo"></div>
            </a>
        </div>
        <language-switch *ngIf="showLanguageSwitch && !isLoggedIn"></language-switch>
        <!-- Search quote-->
        <mod-quickquote *ngIf="isLoggedIn && !hideQuickQuote && !isThemeSelector && !displayModernQuickQuote"></mod-quickquote>
        <modern-quickquote *ngIf="isLoggedIn && !hideQuickQuote && !isThemeSelector && displayModernQuickQuote"></modern-quickquote>
        <nxi-unblu-advisor-app *ngIf="isUnbluEnabled && isUnbluChatEntitled"
                    [unbluVisitorScriptEndpoint]="unbluVisitorScriptEndpoint"
                    [unbluJsAPIScriptEndpoint]="unbluJsAPIScriptEndpoint"
        ></nxi-unblu-advisor-app>
    </div>
</header>

<ng-template #desktopTheme>
    <!--DESKTOP VIEW-->
    <header role="banner" class="fw-Header">
        <div id="investorHeader" class="fw-HeaderComponent">
            <div class="fw-HeaderComponent_LogoContainer">
                <!-- Logo container-->
                <a href="javascript:void(0);" class="fw-HeaderComponent_LogoLink" (click)="redirectHome()">
                    <div attr.aria-label="{{'NXI_PORTAL.LOGOPRELOGIN' | pershingTranslate}} {{ibdName}}{{'NXI_PORTAL.LINK_TO_HOME' | pershingTranslate}}"
                        class="fw-Header_Logo"></div>
                </a>
                <div class="fw-SkipmainContent" *ngIf="isLoggedIn">
                    <a [routerLink]="[]" fragment="maincontent" class="fw-SkipMainContentLink" >Skip to main content</a>
                </div>
            </div>
            <language-switch *ngIf="showLanguageSwitch && !isLoggedIn"></language-switch>
           <div class="fw-HeaderComponent_ActionsContainer"  *ngIf="isLoggedIn && showHeaderActions">
                <go-paperless *ngIf="isLoggedIn && isEdelEnabled && !isDisclosuresPage"></go-paperless>
                <div class="fw-Header_AccopenbtnDesktop">
                    <button *ngIf="isEntitledForAccountOpening && isNewAccOpenEnabled && !hideAcctOpening" (click)="openAnAccount()" mat-stroked-button
                     class="fw-Header_Icons no-border"><span class="small regular-weight">{{ 'NXI_PORTAL_COMPONENTS.OPEN_ACCOUNT' | pershingTranslate}}</span>
                    <em class="far fa-arrow-right margin-left-5"></em>
                  </button>
                  </div>

                <mod-quickquote *ngIf="!hideQuickQuote && !displayModernQuickQuote"></mod-quickquote>
                <modern-quickquote *ngIf="!hideQuickQuote && displayModernQuickQuote"></modern-quickquote>
                <nxi-unblu-advisor-app *ngIf="isUnbluEnabled && isUnbluChatEntitled"
                    [unbluVisitorScriptEndpoint]="unbluVisitorScriptEndpoint"
                    [unbluJsAPIScriptEndpoint]="unbluJsAPIScriptEndpoint"
                ></nxi-unblu-advisor-app>
                <contact-us *ngIf="entitledForConatctUs && !isEquipt"></contact-us>

                <a tabindex="0" role=button class="fw-Header_Icons" *ngIf="!isDisclosuresPage"
                    matTooltip="{{'NXI_PORTAL_COMPONENTS.MESSAGE_CENTER' | translate}}" (click)="messageCenter()"
                    attr.aria-label="{{'NXI_PORTAL_COMPONENTS.MESSAGE_CENTER' | translate}}" role="link">
                    <div class="fw-Header_MessageCenter"></div>
                </a>

                <button mat-icon-button class="fw-Header_Icons" [matMenuTriggerFor]="userProfile" (menuClosed)="isProfileActive = false"
                    (menuOpened)="isProfileActive = true" [class.active]="isProfileActive"
                    matTooltip="{{settingsandLogoutTooltip}}"
                    attr.aria-label="{{settingsandLogoutTooltip}}" [attr.aria-haspopup]="settingsAndLogoutAriaHasPopup">
                    <div #userIcon class="fw-Header_UserIcon"></div>
                </button>
                <mat-menu class="fw-ProfileMenu_Container" #userProfile="matMenu">
                    <profile-menu></profile-menu>
                </mat-menu>
            </div>
        </div>
    </header>
</ng-template>
